import getKhattabatMatchingStore from "../stores/khattabat-stores/matching-stores";
import {
  reducerToNoneIfUndefined,
  reducerToZeroIfUndefined,
  reducerToStringArray
} from "./et3-picker-data-helper";

export const getMatchingSearchCriteria = () => {
  const {
    getMatchGender,
    matchAppLanguage,
    minMatchAgeFilter,
    maxMatchAgeFilter,
    minMatchHeightFilter,
    maxMatchHeightFilter,
    minMatchWeightFilter,
    maxMatchWeightFilter,
    matchNationalityFilter,
    matchResidenceFilter,
    matchResidenceCityFilter,
    isChosenNationalitiesExcluded,
    isChosenResidenceCountriesExcluded,
    matchMarriageType,
    matchMaritalStatus,
    matchHavingKids,
    matchWork,
    matchEducation,
    matchFemaleWorkStudy,
    matchSmoking,
    matchBelongsToATribe,
    matchRelocation,
    matchSkinColor,
    matchReligion,
    isMatchingVeilCriteriaExists,
    isMatchingIncomeCriteriaExists,
    matchFemaleVeil,
    matchMaleIncome,
    matchesIdsResultLimit
  } = getKhattabatMatchingStore();

  return {
    matchGender: getMatchGender(),
    matchAppLanguage: reducerToStringArray(matchAppLanguage.get()),
    minAge: reducerToZeroIfUndefined(
      parseInt(minMatchAgeFilter.get().value, 10)
    ),
    maxAge: reducerToZeroIfUndefined(
      parseInt(maxMatchAgeFilter.get().value, 10)
    ),
    minWeight: reducerToZeroIfUndefined(
      parseInt(minMatchWeightFilter.get().value, 10)
    ),
    maxWeight: reducerToZeroIfUndefined(
      parseInt(maxMatchWeightFilter.get().value, 10)
    ),
    minHeight: reducerToZeroIfUndefined(
      parseInt(minMatchHeightFilter.get().value, 10)
    ),
    maxHeight: reducerToZeroIfUndefined(
      parseInt(maxMatchHeightFilter.get().value, 10)
    ),
    countryCode: reducerToStringArray(matchResidenceFilter.get()),
    nationalityCode: reducerToStringArray(matchNationalityFilter.get()),
    isChosenNationalitiesExcluded: isChosenNationalitiesExcluded.get(),
    isChosenResidenceCountriesExcluded:
      isChosenResidenceCountriesExcluded.get(),
    residenceCity: reducerToStringArray(matchResidenceCityFilter.get()),
    typeOfMarriage: reducerToStringArray(matchMarriageType.get()),
    maritalStatus: reducerToStringArray(matchMaritalStatus.get()),
    havingKids: reducerToNoneIfUndefined(matchHavingKids.get().value),
    work: reducerToStringArray(matchWork.get()),
    education: reducerToStringArray(matchEducation.get()),
    femaleWorkOrStudy: reducerToNoneIfUndefined(
      matchFemaleWorkStudy.get().value
    ),
    smoking: reducerToNoneIfUndefined(matchSmoking.get().value),
    belongsToATribe: reducerToNoneIfUndefined(matchBelongsToATribe.get().value),
    relocation: reducerToNoneIfUndefined(matchRelocation.get().value),
    skinColor: reducerToStringArray(matchSkinColor.get()),
    religion: reducerToStringArray(matchReligion.get()),
    veil: reducerToStringArray(
      isMatchingVeilCriteriaExists.get() ? matchFemaleVeil.get() : []
    ),
    income: reducerToStringArray(
      isMatchingIncomeCriteriaExists.get() ? matchMaleIncome.get() : []
    ),
    limit: reducerToZeroIfUndefined(
      parseInt(matchesIdsResultLimit.get().value, 10)
    )
  };
};
